const serviceTypes = {
  unSet: 0,
  EvaluacionInicial: 1,
  EvaluacionAdicional: 2,
  Terapia: 3,
  Asistentes: 4,
  PruebasAcademicas: 5,
  PruebasAcademicasConDocumento: 6,
  Consultoria: 7,
  CentroDeServicio: 12,
};

export default serviceTypes;
